$(function() {

    'use strict';

    // DETECT TOUCH DEVICE //
    function is_touch_device() {
        return !!('ontouchstart' in window) || (!!('onmsgesturechange' in window) && !!window.navigator.maxTouchPoints);
    }

    // STICKY //
    function sticky() {

        let sticky_point = $('#header').innerHeight() + 100;

        $('#header').clone().attr({
            id: 'header-sticky',
            class: ''
        }).insertAfter('header');

        $(window).scroll(function() {

            if ($(window).scrollTop() > sticky_point) {
                $('#header-sticky').slideDown(300).addClass('header-sticky');
                $('#header .menu ul').css({'visibility': 'hidden'});
            } else {
                $('#header-sticky').slideUp(100).removeClass('header-sticky');
                $('#header .menu ul').css({'visibility': 'visible'});
            }

        });

    }

    // SHOW/HIDE MOBILE MENU //
    function show_hide_mobile_menu() {

        $('.mobile-menu-btn').on('click', function(e) {

            e.preventDefault();
            e.stopPropagation();

            $('#mobile-menu').toggleClass('open');
            $('body').toggleClass('mobile-menu-open');

        });

        $('body').on('click', function() {
            if ($('#mobile-menu').hasClass('open')) {
                $('#mobile-menu').removeClass('open');
                $('body').removeClass('mobile-menu-open');
            }
        });

    }

    // MOBILE MENU //
    function mobile_menu() {

        if ($(window).width() < 992) {

            if ($('#menu').length > 0) {

                if ($('#mobile-menu').length < 1) {

                    $('#menu').clone().attr({
                        id: 'mobile-menu',
                        class: ''
                    }).insertAfter('#header');

                    $('#mobile-menu').on('click', function(e) {
                        e.stopPropagation();
                    });

                    $('#mobile-menu li').each(function() {

                        if ($(this).hasClass('dropdown')) {
                            $(this).append('<span class="arrow"></span>');
                        }

                    });

                    $('#mobile-menu .dropdown .arrow').on('click', function(e) {

                        e.preventDefault();
                        e.stopPropagation();

                        $(this).toggleClass('open').prev('ul').stop().slideToggle(300);

                    });

                }

            }

        } else {

            $('#mobile-menu').removeClass('open');
            $('body').removeClass('mobile-menu-open');

        }

    }

    // SHOW/HIDE SCROLL UP //
    function show_hide_scroll_top() {

        if ($(window).scrollTop() > $(window).height() / 2) {
            $('#scroll-up').fadeIn(300);
        } else {
            $('#scroll-up').fadeOut(300);
        }

    }

    // SCROLL UP //
    function scroll_up() {

        $('#scroll-up').on('click', function() {
            $('html, body').animate({
                scrollTop: 0
            }, 800);
            return false;
        });

    }

    // COOKIES BOX //
    function cookies_box() {

        $('.cookie-popup h5').on('click', function() {
            $(this).parent().toggleClass('maximized');
        });

    }

    // PROGRESS BARS //
    function progress_bars() {
        $('.progress .progress-bar:in-viewport').each(function() {
            if (!$(this).hasClass('animated')) {
                $(this).addClass('animated');
                $(this).animate({
                    width: $(this).attr('data-width') + '%'
                }, 2000);
            }
        });
    }

    $(document).ready(function() {

        // STICKY //
        sticky();

        // SHOW/HIDE MOBILE MENU //
        show_hide_mobile_menu();

        // MOBILE MENU //
        mobile_menu();

        // SHOW/HIDE SCROLL UP //
        show_hide_scroll_top();

        // SCROLL UP //
        scroll_up();

        // COOKIES BOX //
        cookies_box();

        // PROGRESS BARS //
        progress_bars();

        $('[data-toggle="popover"]').popover();

        // MENU //
        $('.menu').superfish({
            popUpSelector: 'ul,.megamenu-container',
            delay: 500,
            animation: {
                opacity: 'hide',
            },
            speed: 'fast',
            autoArrows: true
        });

        // MAIN SLIDER //
        let mainSlider = $('.main-slider .owl-carousel');

        mainSlider.on('initialized.owl.carousel', function() {
            setTimeout(function() {
                $('.main-slider .owl-carousel .slide-details').removeClass('animated');
            }, 300);
        });

        mainSlider.owlCarousel({
            items: 1,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            smartSpeed: 1500,
            loop: true,
            nav: true,
            navText: false,
            dots: true,
            mouseDrag: false,
            touchDrag: true,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut'
        });

        mainSlider.on('translate.owl.carousel', function() {
            $('.main-slider .owl-carousel .slide-details').delay(300).addClass('animated');
        });

        mainSlider.on('translated.owl.carousel', function() {
            $('.main-slider .owl-carousel .slide-details').removeClass('animated');
        });

        // IMAGES SLIDER //
        $('.images-slider').owlCarousel({
            items: 1,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            smartSpeed: 1500,
            loop: true,
            nav: true,
            navText: false,
            dots: true,
            mouseDrag: true,
            touchDrag: true
        });

        // TECHNOLOGIES SLIDER //
        $('.technologies-slider').owlCarousel({
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            smartSpeed: 1000,
            loop: true,
            nav: true,
            navText: false,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
            margin: 25,
            responsive: {
                0: {
                    items: 3
                },
                480: {
                    items: 4
                },
                768: {
                    items: 5
                },
                992: {
                    items: 6
                }
            }
        });

        // ACCORDIONS //
        $('.toggle').on('click', function(e) {

            e.preventDefault();

            let $this = $(this);

            if ($this.next().hasClass('show')) {
                $this.removeClass('active').next().removeClass('show');
                $this.next().slideUp(350);
            } else {
                $('.toggle').removeClass('active');
                $this.parent().parent().find('li .inner').removeClass('show');
                $this.parent().parent().find('li .inner').slideUp(350);
                $this.toggleClass('active').next().toggleClass('show');
                $this.next().slideToggle(350);
            }
        });

        // PARALLAX //
        if (!is_touch_device()) {

            $(window).stellar({
                horizontalScrolling: false,
                verticalScrolling: true,
                responsive: true
            });

        } else {

            $('.parallax').addClass('parallax-disable');

        }

        // ISOTOPE //
        const initPortfolio = () => {
            $('.portfolio-items').imagesLoaded(function() {

                let container = $('.portfolio-items');

                let $grid = container.isotope({
                    itemSelector: 'li',
                    layoutMode: 'masonry',
                    transitionDuration: '0.8s'
                });

                $('.filter li a').on('click', function() {
                    $('.filter li a').removeClass('active');
                    $(this).addClass('active');

                    let selector = $(this).attr('data-filter');
                    container.isotope({
                        filter: selector
                    });

                    return false;
                });

                let $isotope = $grid.data('isotope');

                $(window).resize(function() {
                    container.isotope();
                });

                if ($('.portfolio').length > 0) {
                    new InfiniteScroll('.portfolio-items', {
                        path: portfolioPagination + 'page=\{\{#\}\}',
                        append: '.portfolio-item',
                        history: false,
                        hideNav: '.projects-pagination',
                        status: '.page-load-status',
                        outlayer: $isotope,
                    });
                }

            });
        };
        initPortfolio();

        // GOOGLE MAPS //
        $('.map').each(function() {

            let data_zoom = 15,
                data_height,
                data_popup = false;

            if ($(this).attr('data-zoom') !== undefined) {
                data_zoom = parseInt($(this).attr('data-zoom'), 10);
            }

            if ($(this).attr('data-height') !== undefined) {
                data_height = parseInt($(this).attr('data-height'), 10);
            }

            if ($(this).attr('data-address-details') !== undefined) {

                data_popup = true;

                let infowindow = new google.maps.InfoWindow({
                    content: $(this).attr('data-address-details')
                });

            }

            $(this)
                .gmap3({
                    address: $(this).attr('data-address'),
                    zoom: data_zoom,
                    mapTypeId: 'Edris',
                    mapTypeControlOptions: {
                        mapTypeIds: ['Edris', google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE]
                    },
                    scrollwheel: false
                })
                .marker([
                    {address: $(this).attr('data-address')}
                ])
                .on({
                    click: function(marker, event) {
                        if (data_popup) {
                            infowindow.open(marker.get('map'), marker);
                        }
                    }
                })
                .styledmaptype(
                    'Edris',
                    [
                        {
                            "featureType": "all",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#CC0000"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative.country",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative.locality",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#c4c4c4"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative.neighborhood",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#db2222"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 21
                                },
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.business",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#cc0000"
                                },
                                {
                                    "lightness": "0"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "visibility": "on"
                                },
                                {
                                    "weight": "4.53"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "color": "#ff3232"
                                },
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#575757"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "color": "#2c2c2c"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#999999"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#111111"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#aeaeae"
                                }
                            ]
                        }
                    ],
                    { name: "Edris" }
                );

            $(this).css('height', data_height + 'px');

        });

        $('.more-details-btn').on('click', function(e) {
            e.preventDefault();
            $(this).closest('ul').next('.more-details').slideDown(250);
        });

        $('.request-offer-btn').on('click', function() {

            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

                let target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 70
                    }, 500);

                    return false;

                }

            }
        });

    });

    // WINDOW SCROLL //
    $(window).scroll(function() {

        show_hide_scroll_top();
        progress_bars();

    });

    // WINDOW RESIZE //
    $(window).resize(function() {

        mobile_menu();

    });

    $(document).on('click', '[data-toggle="modal"]', function(e){
        e.preventDefault();
        $($(this).data("target")+' .modal-dialog').load($(this).data("remote"));
    });
    $(document).on('submit', '#apply-form', function(e)
    {
        e.preventDefault();
        $(this).find('button[type="submit"]').attr('disabled', true).addClass('disabled');
        $('#alert-danger').html('').addClass('d-none');
        $('#alert-success').addClass('d-none');
        let url = $(this).attr('action');
        let formData = new FormData();
        formData.append('name', $(this).find('#name').val());
        formData.append('cv', $(this).find('#cv')[0].files[0] ?? null);
        axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(() => {
            $('#alert-success').removeClass('d-none');
            $('.form-group').remove();
            $(this).find('button[type="submit"]').remove();
        })
            .catch(error => {
                let errorsHtml = '';
                $.each( error.response.data.errors, function( key, value ) {
                    // We loop through the error to see if there are multiple error associated with the field
                    $.each( value, function( key2, error ) {
                        errorsHtml += `${error}<br>`;
                    });
                });
                $('#alert-danger').html(errorsHtml).removeClass('d-none');
                $(this).find('button[type="submit"]').attr('disabled', false).removeClass('disabled');
            });
    });

    window.getCookie = function(name) {
        try {
            let cookie = JSON.parse(Cookies.get(name));
            return cookie.showGDPR;
        }
        catch(e)
        {
            return false;
        }
    };

    window.setCookie = function(name) {
        let data = {
            showGDPR: true,
            analytics: $('#gdpr-analytics').prop('checked'),
            marketing: $('#gdpr-marketing').prop('checked'),
        };
        Cookies.set(name, JSON.stringify(data), { expires: 7 });
    }

    if (!getCookie('gdpr_cookie')) {
        $('#gdpr-popup').removeClass('d-none').addClass('d-block');
    }

    window.saveCookie = function() {
        setCookie('gdpr_cookie');
        $('#gdpr-popup').removeClass('d-block').addClass('d-none');
    }

    if(!Cookies.get('popup') && $('#newsletter-popup').length)
    {
        setTimeout(function()
        {
            $.magnificPopup.open({
                items: {
                    src: '#newsletter-popup'
                },
                type: 'inline',
                tLoading: '',
                mainClass: 'mfp-newsletter mfp-flip-popup',
                callbacks: {
                    close: function() {
                        Cookies.set('popup', true);
                    }
                }
            });
        }, 5000);

        $('#popup-btn').on('click', function()
        {
            Cookies.set('popup', true);
        });
    }
});
